export default __webpack_public_path__ + "static/media/dinheiro.ff7b2dd5.svg";